export default __webpack_public_path__ + "static/media/ATRkit.9c6e9efa.png";